import React from 'react';
import AppShowcasePage from './AppShowcasePage';
import { appShowcases } from '../content/appShowcases';

export default function CareerPilotAI() {
  return <AppShowcasePage slug="careerpilot-ai" content={appShowcases['careerpilot-ai']} />;
}
